export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7598.fa91979d.jpg";